const topbarMobileLinks = document.querySelectorAll('.blockpromotile_bottom a.navigation-mobile_btn');
topbarMobileLinks.forEach((button) => {
  button.addEventListener('click', async (ev) => {
    ev.preventDefault();
    const buttonLink = button.getAttribute('data-link');
    const buttonCopy = button.getAttribute('data-copy');

    const promobarMenuLinkDataLayer = {
      event: 'navigation_interaction',
      section: 'promo_top_bar',
      element: 'text_button',
      element_value: buttonCopy,
      interaction_type: 'click',
    };

    await dataLayerPromise(promobarMenuLinkDataLayer);
    continueLinkClickEvent(ev, buttonLink);
  });
});

const navigationMobileTiles = document.querySelectorAll('.blockpromotile__wrapper-inner.mobile-wrapper a.promo_item');
const navigationDesktopTiles = document.querySelectorAll('.blockpromotile__wrapper.desktop-wrapper a.promo_item');
const navigationMobileMainMenuTales = document.querySelectorAll(
  '.categorieslist__wrapper .blockpromotile__wrapper .blockpromotile__wrapper-inner > a'
);
const navigationPromoSpaceTiles = [
  ...navigationMobileTiles,
  ...navigationDesktopTiles,
  ...navigationMobileMainMenuTales,
];

navigationPromoSpaceTiles.forEach((button) => {
  button.addEventListener('click', async (ev) => {
    ev.preventDefault();
    const buttonLink = button.getAttribute('data-link');
    const buttonCopy = button.getAttribute('data-copy');

    const promobarMenuLinkDataLayer = {
      event: 'navigation_interaction',
      section: 'promo_space',
      element: 'image_tile',
      element_value: buttonCopy,
      interaction_type: 'click',
    };

    await dataLayerPromise(promobarMenuLinkDataLayer);
    continueLinkClickEvent(ev, buttonLink);
  });
});

const mobileNavigationCategoriesButtons = document.querySelectorAll(
  '.mobile_nav .categorieslist__sidebar-wrapper .categorieslist__list-item a'
);
const desktopNavigationCategoriesButtons = document.querySelectorAll(
  '.desktop_nav.main_nav .categorieslist__sidebar-wrapper .categorieslist__list-item a'
);

const navigationCategoriesButtons = [...mobileNavigationCategoriesButtons, ...desktopNavigationCategoriesButtons];
navigationCategoriesButtons.forEach((button) => {
  button.addEventListener('click', async (ev) => {
    ev.preventDefault();

    const categoriesMenuLinkDataLayer = {
      event: 'navigation_interaction',
      section: 'categories',
      element: 'text_button',
      element_value: button.innerText && button.innerText?.toLowerCase().replace(/\s/g, '_'),
      interaction_type: 'click',
    };

    await dataLayerPromise(categoriesMenuLinkDataLayer);
    continueLinkClickEvent(ev, button.href);
  });
});

const mobileNavigationCategoriesAllProductsButtons = document.querySelectorAll('.mobile_all_products_container a');

const desktopNavigationCategoriesAllProductsButtons = document.querySelectorAll('.collection-container a.all_product');

const navigationCategoriesAllProductsButtons = [
  ...mobileNavigationCategoriesAllProductsButtons,
  ...desktopNavigationCategoriesAllProductsButtons,
];
navigationCategoriesAllProductsButtons.forEach((button) => {
  button.addEventListener('click', async (ev) => {
    ev.preventDefault();
    const buttonCategory = button.getAttribute('data-categories');

    const categoriesAllProductsButtonDataLayer = {
      event: 'navigation_interaction',
      section: `product_listing_` + buttonCategory?.toLowerCase().replace(/[\s-]/g, '_'),
      element: 'product_tile',
      element_value: buttonCategory?.toLowerCase().replace(/[\s-]/g, '_'),
      interaction_type: 'click',
    };

    await dataLayerPromise(categoriesAllProductsButtonDataLayer);
    continueLinkClickEvent(ev, button.href);
  });
});

const navigationDesktopProductCards = document.querySelectorAll(
  '.desktop_nav.main_nav .categorieslist__contents .collection-container a.product-container.product'
);

const navigationMobileProductCards = document.querySelectorAll(
  '.mobile_nav .mobile_products_container-inner .mobile_products a.product-container'
);

const navigationProductCards = [...navigationDesktopProductCards, ...navigationMobileProductCards];

if (navigationProductCards.length) {
  navigationProductCards.forEach((link) => {
    link.addEventListener('click', async (ev) => {
      ev.preventDefault();

      const productCategory = link.getAttribute('data-categories');
      const productTitle = link.getAttribute('data-product');

      const productDataLayer = {
        event: 'product_tile_clicked',
        section: 'navigation_product_listing',
        element: 'medium_product_tile',
        element_value: productTitle,
        product_category: productCategory,
        interaction_type: 'click',
      };

      await dataLayerPromise(productDataLayer);
      continueLinkClickEvent(ev, link.href);
    });
  });
}

const categoriesContentAccordions = document.querySelectorAll('.categories_content.menu-accordion');

categoriesContentAccordions.forEach((accordion) => {
  accordion.querySelector('summary').addEventListener('click', () => {
    const isOpen = accordion.getAttribute('open') == null;
    const isProducts = accordion.getAttribute('data-type') === 'products';

    if (isOpen) {
      dataLayerPromise({
        element: 'text_rollup',
        interaction_type: 'click',
        section: 'test_folded_section',
        event: 'navigation_interaction',
        element_value: isProducts ? 'wedlug_produktu' : 'wedlug_potrzeby',
      });
    }
  });
});

const triggerGTMEventAndRedirect = async (ev, link, data) => {
  const productDataLayer = {
    interaction_type: 'click',
    section: 'test_unfolded_section',
    event: 'navigation_interaction',
    ...data,
  };

  await dataLayerPromise(productDataLayer);
  continueLinkClickEvent(ev, link.href);
};

const mobileProducts = document.querySelectorAll(
  '.categorieslist__sidebar-wrapper .categories_content .mobile_products a'
);

mobileProducts.forEach((link) => {
  link.addEventListener('click', (ev) => {
    ev.preventDefault();
    triggerGTMEventAndRedirect(ev, link, {
      element: 'product_tile',
      element_value: link.getAttribute('data-product'),
    });
  });
});

const allProductsButton = document.querySelectorAll('.categorieslist__sidebar-wrapper .mobile_all_products_btn');

allProductsButton.forEach((link) => {
  link.addEventListener('click', (ev) => {
    ev.preventDefault();
    triggerGTMEventAndRedirect(ev, link, {
      element: 'all_products_button',
    });
  });
});

const allNeedsButtons = document.querySelectorAll('.categorieslist__sidebar-wrapper .single-need');

allNeedsButtons.forEach((link) => {
  link.addEventListener('click', (ev) => {
    ev.preventDefault();
    triggerGTMEventAndRedirect(ev, link, {
      element: 'need_button',
      element_value: link.getAttribute('data-need'),
    });
  });
});

const mobileNeedsCategories = document.querySelectorAll('.mobile_needs_collection_list a.main-menu__link');
// const desktopNeedsCategories = document.querySelectorAll(
//   '.desktop_needs_nav .categorieslist__sidebar-wrapper .categorieslist__list-item a'
// );

const needsLinks = [...mobileNeedsCategories];

needsLinks.forEach((link) => {
  link.addEventListener('click', async (ev) => {
    ev.preventDefault();
    await dataLayerPromise({
      element: 'text_button',
      element_value: link.getAttribute('data-category'),
      interaction_type: 'click',
      section: 'needs_listing',
      event: 'navigation_interaction',
    });
    continueLinkClickEvent(ev, link.href);
  });
});

const topBarDesktopCategoryLinks = document.querySelectorAll('.header .header__left-menu a.header__nav-trigger');

topBarDesktopCategoryLinks.forEach((link) => {
  link.addEventListener('click', async (ev) => {
    ev.preventDefault();
    const categoryValue = link.getAttribute('data-categories') || '';

    await dataLayerPromise({
      event: 'navigation_interaction',
      section: 'top_bar',
      element: 'text_button',
      element_value: categoryValue,
      interaction_type: 'click',
    });
    continueLinkClickEvent(ev, link.href);
  });
});
